<template>
  <section>
    <HeroBanner
      title="Baby Care"
      subtitle="Nurture your precious Floof."
      background-color="is-info"
      icon="baby-buggy"
    />

    <main role="main">
      <div
        v-for="(section, index) in productSections"
        :key="index"
        class="container section"
      >
        <article>
          <p class="title">{{ section.title }}</p>
          <p class="subtitle">{{ section.subtitle }}</p>
          <b-message v-if="section.alert" type="is-warning" has-icon>
            {{ section.alert }}
          </b-message>

          <div class="content">
            <p v-html="section.description" />

            <ProductList :product-category="section.productCategory" />
          </div>
        </article>
      </div>
    </main>
  </section>
</template>

<script>
import HeroBanner from '@/components/HeroBanner'
import ProductList from '@/components/ProductList'
import { getPageMeta } from '@/utils'

const meta = {
  pageTitle: 'Baby Care',
  pageDescription:
    'Your baby chinchilla is considered a kit when it is less than 8 weeks old. It is critical that you provide the right nutrition, have a comfortable and safe environment, and make sure their growth is on track',
  pageURL: 'http://www.chinchillaessentials.com/baby-care',
  pageImg:
    'https://www.chinchillaessentials.com/img/chinchilla_baby_and_mother.jpeg'
}

export default {
  name: 'BabyCare',
  components: {
    HeroBanner,
    ProductList
  },
  metaInfo: () => getPageMeta(meta),
  data() {
    return {
      productSections: [
        {
          title: 'Food',
          subtitle: 'Provide critical nutrition to your growing Floof.',
          description: '',
          productCategory: 'food-baby'
        },
        {
          title: 'Housing',
          subtitle:
            'Have a comfortable and safe environment for your growing Floof.',
          description: `
            <p>When baby chins are born, they can climb right after birth. Therefore, a single-level cage is needed for both the mother and the baby to prevent the baby chinchillas from falling and injuring themselves.</p>
            <p>The cage should have solid bottom, babies have small feet that can get caught on the bottom or sides of a cage with large gaps. The size of the cage depend on the number of kits. For 3 to 4 kits, ideal cage size should be about 16 inches by 18 inches. Spaces between the bars should be no more than half inch apart. A large wooden box should be kept in the cage for the kits to sleep in, babies will likely curl up together to keep warm.</p>
            <p>As a general rule, babies should be weaned at 8 to 12 weeks old. The kits can be moved to a new cage away from their mother after they are weaned. However, the parents should still stay in vocal range of the kit. This will help with the baby’s social behavior and provide comfort in knowing that their parents are close by. The babies can be housed on their own or with chins of the same sex. </p>
          `,
          productCategory: 'housing-baby'
        },
        {
          title: 'Bedding',
          subtitle: 'Keeping the house clean for your baby Floof.',
          description:
            'Bedding should be replaced at least once a week. It is important to know that pine and aromatic shavings are dangerous for chinchillas if ingested, so we’ve provided some links to safe and affordable bedding material below.',
          productCategory: 'bedding'
        },
        {
          title: 'Warmth',
          subtitle: 'Keep the floof warm and cozy',
          description: `
            <p>If in a situation where the mother is not present, the best way to keep the kit warm is to use fleece on the bottom of the cage and use a heating pad on warm or low. Make sure to place the heating pad only on half of the cage bottom because the kit may want to cool down if he/she wants to.</p>
            <p>A small stuffed animal is also recommended of cuddling and provide a sense of safety. Make sure that the stuffed animal does not have anything that the baby chin can choke on, avoid fake whiskers and plastic decorations.</p>
          `,
          productCategory: 'warmth'
        },
        {
          title: 'Scales',
          subtitle: "Make sure the Floof's growth is on track",
          description:
            "Weighing your chinchilla regularly is an effective way to make sure he/she is healthy. Kitchen food scales are perfect for weighing the baby floofs, especially since the kits generally weigh 30-60 grams at birth. If you don't happen to have one, we recommend these very affordable ones below.",
          productCategory: 'scales'
        }
      ]
    }
  }
}
</script>
